<h2 mat-dialog-title>Complete task?</h2>

<div mat-dialog-content class="dialog-content">
  <p>
    This will mark task #{{ data.taskId }} as completed and mark the linked parts as received.
  </p>

  <div class="parts-list" *ngIf="data.partsOrders?.length">
    <div class="parts-item" *ngFor="let order of data.partsOrders">
      <span>{{ order.title || 'Untitled order' }}</span>
      <small *ngIf="order.supplier">{{ order.supplier }}</small>
    </div>
  </div>
</div>

<div mat-dialog-actions class="dialog-actions">
  <button mat-button (click)="cancel()">Cancel</button>
  <button mat-flat-button color="primary" (click)="confirm()" cdkFocusInitial>
    Complete and receive parts
  </button>
</div>
